import * as React from "react"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import ContactUsSection from "../../components/contact-us-section"
import RichMediaShelf from "../../components/rich-media-shelf"
import RecommendedReading from "../../components/recommended-reading"
import {Link} from "gatsby"
// import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Breadcrumb from "../../components/breadcrumbs"

const RichMediaShelfPage = ({location}) => (
    <Layout>
        <Seo title="Digital Shelf - Enhanced Content" />

        <div className='bg-primary'>
            <div className='container position-relative'>
                <div className='row justify-content-center'>
                    <div className='col-lg-8 py-6 justify-content-center d-flex flex-column'>
                        <h1 className='text-white text-uppercase text-center mb-4'>Enhanced Content Hosting</h1>
                        <div className='text-white mb-4 font-md'>
                            Enhanced content, also known as A+ Content or Rich Media, is a term for anything that goes beyond basic images and product descriptions on a Walmart.com page. You can quickly and easily add enhanced content to your Walmart items using SKU Ninja’s online enhanced content builder!
                        </div>
                        <Link to='https://www.flywheeldigital.com/contact-us' className='mx-auto'><button className='btn btn-yellow'>Learn More</button></Link>
                    </div>
                </div>
            </div>
        </div>

        <div className="container py-4">
            <div className='row justify-content-center bg-warning bg-opacity-80 card m-1 p-2 text-black'>
                <p> Walmart has <b>temporarily suspended the publication of Rich Media</b> on Walmart.com product detail pages <b>within specific product categories</b> to implement compliance measures in accordance with the <a href="https://app.leg.wa.gov/RCW/default.aspx?cite=19.373&full=true" target="_blank">My Health My Data Act</a>. </p>
                <p>For more details, please <Link to='https://www.whytespyder.com/software/rich-media-suppression/'>click here</Link> to read the update from Walmart regarding the temporary suspension of Rich Media on Walmart.com product detail pages for specific product categories.</p>
            </div>
        </div>

        <div className='py-2'>
            <RichMediaShelf/>
        </div>

        <div className='py-6'>
            <ContactUsSection/>
        </div>
    </Layout>
)

export default RichMediaShelfPage